module.exports = __webpack_public_path__ + "static/img/warehouse08.c27f426.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warehouse08.jpg
// module id = Y+Ye
// module chunks = 0